import { render, staticRenderFns } from "./recovery_codes.vue?vue&type=template&id=6a74a8cc&scoped=true"
import script from "./recovery_codes.vue?vue&type=script&lang=js"
export * from "./recovery_codes.vue?vue&type=script&lang=js"
import style0 from "./recovery_codes.vue?vue&type=style&index=0&id=6a74a8cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a74a8cc",
  null
  
)

export default component.exports